// Tradução de borda backend ↔ modelo da UI (status, contadores, bloqueio).
import type { TicketStatus, Counters } from '../../domain/types'
import type { BackendTicketStatus, BlockReason, CountersDto } from '../dto/journey.dto'

// O backend (ToBackendTicketStatus) NÃO achata: devolve Confirmed/Checked/Reopened tais quais.
// Só "Waiting" (fallback de status desconhecido) é mapeado para "Opened" (genérico de espera).
export function ticketStatus(b: BackendTicketStatus): TicketStatus {
  switch (b) {
    case 'Opened': return 'Opened'
    case 'Authorized': return 'Authorized'
    case 'Confirmed': return 'Confirmed'
    case 'Checked': return 'Checked'
    case 'Reopened': return 'Reopened'
    case 'Waiting': return 'Opened'
    case 'Called': return 'Called'
    case 'InProgress': return 'Started'
    case 'Completed': return 'Completed'
    case 'Canceled': return 'Canceled'
    default: return 'Opened'
  }
}

export function counters(c: CountersDto): Counters {
  return { total: c.total, aguardando: c.waiting, emAtendimento: c.active, completos: c.completed, cancelados: c.canceled }
}

export function blockToRazao(b: BlockReason): 'nivel' | 'concorrente' | null {
  if (b === 'PreviousLevelPending') {return 'nivel'}
  if (b === 'ActivePeerOnLevel') {return 'concorrente'}
  return null
}
